// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1JTax","errors":"Errors_errors__317cB"};